<div class="grid gap-4">
  <webmodule-order-panel>
    <ng-container heading>
      <h3 [innerHTML]="'block.details.detail.heading' | translate" class="mb-0"></h3>
    </ng-container>
    <ng-container content>
      <form [formGroup]="form" novalidate >
        <fieldset [disabled]="pendingRequest()">
          <div class="grid grid-cols-4 gap-4 mb-4">
            <div class="input-group  col-span-2">
              <label class="label" for="firstName">{{ 'block.details.input.first-name.label' | translate }}</label>
              <div>
                <input [placeholder]="'block.details.input.first-name.placeholder' | translate "
                       class="control"
                       formControlName="firstName"
                       id="firstName"
                       name="firstName"
                       type="text">
              </div>
            </div>
            <div class="input-group  col-span-2">
              <label class="label" for="lastName">{{ 'block.details.input.last-name.label' | translate }}</label>
              <div>
                <input [placeholder]="'block.details.input.last-name.placeholder' | translate"
                       class="control"
                       formControlName="lastName"
                       id="lastName"
                       name="lastName"
                       type="text">
              </div>
            </div>
            <div class="input-group  col-span-2">
              <label class="label" for="email">{{ 'block.details.input.email.label' | translate }}</label>
              <div>
                <input [placeholder]="'block.details.input.email.placeholder' | translate"
                       class="control"
                       formControlName="email"
                       id="email"
                       name="email"
                       type="text">
              </div>
            </div>
            <div class="input-group  col-span-2">
              <label class="label" for="phoneNumber">{{ 'block.details.input.phone-number.label' | translate }}</label>
              <div>
                <input [placeholder]="'block.details.input.phone-number.placeholder' | translate"
                       class="control"
                       formControlName="phoneNumber"
                       id="phoneNumber"
                       name="phoneNumber"
                       type="text">
              </div>
            </div>

            <div class="input-group col-span-4">
              <label class="label" for="companyName">{{ 'block.details.input.company-name.label' | translate }}</label>
              <div>
                <input [placeholder]="'block.details.input.company-name.label' | translate"
                       class="control"
                       formControlName="companyName"
                       id="companyName"
                       name="companyName"
                       type="text">
              </div>
            </div>
            @if (form.controls.companyName.value) {
              <div class="input-group col-span-4">
                <label class="label" for="companyName">{{ 'block.details.input.coc-number.label' | translate }}</label>
                <div>
                  <input class="control"
                         formControlName="kvkNumber"
                         id="kvkNumber"
                         name="kvkNumber"
                         [placeholder]="'block.details.input.coc-number.label' | translate"
                         type="text">
                </div>
              </div>
            }
          </div>
        </fieldset>
      </form>
    </ng-container>
  </webmodule-order-panel>

  <webmodule-order-panel>
    <ng-container heading>
      <h3 class="mb-0">{{ 'block.details.delivery.heading' | translate }}</h3>
    </ng-container>

    <ng-container content>
      <form [formGroup]="form" novalidate>
        <fieldset [disabled]="pendingRequest()">
          <div class="grid gap-4 mb-4">
            @if (address(); as address) {
              <div class="">
                <webmodule-order-alert title="Belangrijk" variation="warning">{{ 'block.details.delivery.based-on-address' | translate }}</webmodule-order-alert>
                <div class="mt-2 p-2 border border-gray-200">
                  <p>{{ address.street }} {{ address.houseNumber }}
                    @if (address.houseNumberAddition; as addition) {
                      {{ addition }}
                    }
                  </p>
                  <p class="mb-0">{{ address.postcode }} {{ address.city }}</p>
                </div>
              </div>
            }

            <div class="input-group horizontal">
                <div>
                  <label class="label" for="wishDate">{{ 'block.details.input.preferred-date.label' | translate }}</label>
                  <p class="text-sm leading-6 text-gray-500">{{ 'block.details.input.preferred-date.description' | translate }}</p>
                </div>
                <div>
                  <input [max]="maxDate"
                         [min]="minDate"
                         class="control"
                         formControlName="wishDate"
                         id="wishDate" name="wishDate" type="date">
                </div>
              </div>
              <div class="input-group horizontal">
                <div>
                  <label class="label" for="paymentInterval">{{ 'block.details.input.payment-term.label' | translate }}</label>
                  <p class="text-sm leading-6 text-gray-500">{{ 'block.details.input.payment-term.description' | translate }}</p>
                </div>
                <div>
                  <select class="control"
                          formControlName="paymentInterval"
                          id="paymentInterval"
                          name="paymentInterval">
                    <option [value]="PaymentInterval.monthly">{{ 'block.details.input.payment-interval.options.monthly' | translate }}</option>
                    <option [value]="PaymentInterval.quarterly">{{ 'block.details.input.payment-interval.options.quarterly' | translate }}</option>
                    <option [value]="PaymentInterval.yearly">{{ 'block.details.input.payment-interval.options.yearly' | translate }}</option>
                  </select>
                </div>
              </div>
              <div class="input-group horizontal">
                <div>
                  <label class="label" for="iban">{{ 'block.details.input.iban-number.label' | translate }}</label>
                  <p class="text-sm leading-6 text-gray-500">{{ 'block.details.input.iban-number.description' | translate }}</p>
                </div>
                <div>
                  <input [placeholder]="'block.details.input.iban-number.placeholder' | translate"
                         class="control"
                         formControlName="iban"
                         id="iban"
                         name="iban"
                         type="text">
                </div>


              </div>

              <div class="input-group horizontal">
                <div>
                  <label class="label" for="reseller">{{ 'block.details.input.partner-code.label' | translate }}</label>
                  <p class="text-sm leading-6 text-gray-500">{{ 'block.details.input.partner-code.description' | translate }}</p>
                </div>
                <div>
                  <input [placeholder]="'block.details.input.partner-code.placeholder' | translate "
                         class="control"
                         formControlName="reseller"
                         id="reseller"
                         name="reseller"
                         type="text">
                </div>

              </div>
            </div>
          </fieldset>
        </form>

        <form [formGroup]="agreeForm">
          <fieldset [disabled]="pendingRequest()">
            <div class="relative flex items-start">
              <div class="flex h-6 items-center">
                <input aria-describedby="sepa-description"
                       class="h-4 w-4 rounded border-border-300 text-secondary-600 focus:ring-secondary-600"
                       formControlName="sepa"
                       id="sepa"
                       name="sepa"
                       type="checkbox">
              </div>
              <div class="ml-3 text-sm leading-6">
                <label class="font-medium text-gray-900 cursor-pointer" for="sepa">Automatische incasso</label>
                <p class="text-gray-500" id="sepa-description">Ik machtig Multifiber B.V. om het abonnementsbedrag, gebruikskosten en eventuele eenmalige kosten af te schrijven van mijn bankrekening <strong>{{ form.controls.iban.value }}</strong> .</p>
              </div>
            </div>

            <div class="relative flex items-start">
              <div class="flex h-6 items-center">
                <input aria-describedby="terms-description"
                       class="h-4 w-4 rounded border-border-300 text-secondary-600 focus:ring-secondary-600"
                       formControlName="terms"
                       id="terms"
                       name="terms"
                       type="checkbox">
              </div>
              <div class="ml-3 text-sm leading-6">
                <label class="font-medium text-gray-900 cursor-pointer" for="terms">Ik ga akkoord met de Algemene Voorwaarden</label>
                <p class="text-gray-500" id="terms-description">Bekijk <a href="#" rel="noreferrer" target="_blank">hier</a> de algemene voorwaarden van Multifiber B.V.</p>
              </div>
            </div>

            @if (carrier) {
              <div class="relative flex items-start">
                <div class="flex h-6 items-center">
                  <input aria-describedby="supplierTerms-description"
                         class="h-4 w-4 rounded border-border-300 text-secondary-600 focus:ring-secondary-600"
                         formControlName="supplierTerms"
                         id="supplierTerms"
                         name="supplierTerms"
                         type="checkbox">
                </div>
                <div class="ml-3 text-sm leading-6">
                  <label class="font-medium text-gray-900 cursor-pointer" for="supplierTerms">Ik ga akkoord met de Algemene Voorwaarden van leverancier <strong>{{ carrier.name }}</strong></label>
                  <p [innerHTML]="carrier.terms" class="text-gray-500" id="supplierTerms-description"></p>
                </div>
              </div>
            }
          </fieldset>
        </form>
      </ng-container>
    </webmodule-order-panel>
  </div>
